export const QUALITY = {
  high: { clouds: 560, frontClouds: 90, particles: 900, dpr: [1, 1.75], tex: 512 },
  medium: { clouds: 320, frontClouds: 55, particles: 450, dpr: [1, 1.25], tex: 384 },
  low: { clouds: 170, frontClouds: 30, particles: 220, dpr: [1, 1], tex: 256 },
};

export function detectQuality() {
  const ua = navigator.userAgent;
  const mobile = /Android|iPhone|iPad|iPod/i.test(ua) || window.innerWidth < 768;
  const mem = navigator.deviceMemory || 8;
  const cores = navigator.hardwareConcurrency || 4;
  if (mem <= 2 || cores <= 2) return 'low';
  if (mobile || mem <= 4 || cores <= 4) return 'medium';
  return 'high';
}

export function supportsWebGL() {
  try {
    const c = document.createElement('canvas');
    return !!(c.getContext('webgl2') || c.getContext('webgl'));
  } catch {
    return false;
  }
}

export const isTouchDevice = () => window.matchMedia?.('(pointer: coarse)').matches;
